// Add your custom JS here.


	(function ($) {

	  const API_BASE = document.querySelector('link[rel="https://api.w.org/"]').href;

	  // DOM ready
	  $(function () {
	    // Set up Leaflet map
	    const map = document.getElementById("map");
	    if (map) {
	      setupLeafletMap(map);
	    }

	    // Scroll-triggered slide-in animation for Gutenberg block columns
	    // Each column is observed individually so that on mobile (stacked layout)
	    // every column animates only when it itself enters the viewport.
	    // Columns inside a nested .wp-block-columns (i.e. whose parent row is itself
	    // inside a .wp-block-column) are excluded from the animation.
	    if ('IntersectionObserver' in window) {
	      const columns = Array.from(document.querySelectorAll('.wp-block-columns > .wp-block-column')).filter(col => !col.parentElement.closest('.wp-block-column'));

	      // Pre-set the stagger index based on sibling position so the CSS
	      // delay still works on desktop where columns share the same row.
	      columns.forEach(col => {
	        const siblings = Array.from(col.parentElement.children).filter(el => el.classList.contains('wp-block-column'));
	        col.style.setProperty('--col-index', siblings.indexOf(col));
	      });
	      const colObserver = new IntersectionObserver(entries => {
	        entries.forEach(entry => {
	          if (!entry.isIntersecting) return;
	          entry.target.classList.add('is-visible');
	          colObserver.unobserve(entry.target);
	        });
	      }, {
	        threshold: 0.25
	      });
	      columns.forEach(col => colObserver.observe(col));
	    } else {
	      // Fallback: make all columns visible immediately (top-level only)
	      Array.from(document.querySelectorAll('.wp-block-columns > .wp-block-column')).filter(col => !col.parentElement.closest('.wp-block-column')).forEach(col => col.classList.add('is-visible'));
	    }
	  });

	  /**
	   * Get posts data from the WordPress REST API
	   * @param {string} slug - The post type slug
	   * @param {number} perPage - The number of posts to retrieve
	   * @returns {Promise<object[]>} - An array of post objects
	   */
	  async function fetchPosts(slug, perPage) {
	    const response = await fetch(`${API_BASE}wp/v2/${slug}?per_page=${perPage}`);
	    if (!response.ok) {
	      const message = `An error has occured: ${response.status}`;
	      throw new Error(message);
	    }
	    const data = await response.json();
	    return data;
	  }

	  /**
	   * Set up Leaflet map
	   * @param {HTMLElement} el - The map element
	   */
	  function setupLeafletMap(el) {
	    const postSlug = el.dataset.mapId;
	    const postsPerPage = 100;
	    const mapOptions = {
	      center: [41.389, 2.113],
	      zoom: 9
	    };
	    const map = L.map(el, mapOptions);
	    const customIcon = L.icon({
	      iconUrl: siteurl + "/wp-content/themes/upcgaudeix/img/icon-map.png",
	      iconSize: [50, 50],
	      // set the size of the icon
	      iconAnchor: [25, 50] // set the anchor point of the icon
	    });

	    L.Marker.prototype.options.icon = customIcon;

	    /**
	     * Create markers on the Leaflet map
	     * @param {object[]} posts - An array of post objects
	     */
	    const createMarkers = posts => {
	      if (!posts || !posts.length) {
	        console.warn("No markers found.", posts);
	        return;
	      }
	      posts.forEach(post => {
	        const id = post.id;
	        const {
	          coordinates: {
	            latitude,
	            longitude
	          } = {}
	        } = post.acf;
	        if (latitude && longitude) {
	          const marker = L.marker([latitude, longitude]);
	          markers.addLayer(marker);
	          marker.on("click", event => {
	            $(`.espais-patrimoni`).offcanvas("hide");
	            $(`#offcanvas-${id}`).offcanvas("toggle");
	          });
	        }
	      });
	      map.addLayer(markers);
	    };
	    L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
	      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors © <a href="https://carto.com/attributions">CARTO</a>',
	      subdomains: "abcd",
	      minZoom: 8,
	      maxZoom: 20
	    }).addTo(map);

	    // Create a marker cluster group
	    const markers = L.markerClusterGroup({
	      singleMarkerMode: true
	    });

	    // Get the markers from the WP REST API and add them to the map
	    fetchPosts(postSlug, postsPerPage).then(createMarkers);
	  }
	})(jQuery);
// Esperem que la font carregui i mesurem amplada
window.addEventListener('load', () => {


});

	// ---------------------------------------------------------------------------
	// Scroll-triggered slide-in animation for facetwp grid items
	// Items slide up from below with a stagger delay based on their masonry
	// column position (--item-col CSS variable).
	// ---------------------------------------------------------------------------

	/**
	 * Assign column indices and set up IntersectionObserver for .item-document
	 * elements inside .facetwp-template.
	 * Safe to call multiple times (e.g. after FacetWP reloads): already-visible
	 * items keep their .is-visible class; only newly added items are observed.
	 */
	function initGridItemAnimation() {
		const container = document.querySelector('.facetwp-template');
		if (!container) return;

		const items = Array.from(container.querySelectorAll('.item-document'));
		if (!items.length) return;

		// Derive column index from offsetLeft: items sharing the same left offset
		// belong to the same masonry column.
		const uniqueLefts = [...new Set(items.map(item => item.offsetLeft))].sort((a, b) => a - b);
		items.forEach(item => {
			item.style.setProperty('--item-col', uniqueLefts.indexOf(item.offsetLeft));
		});

		if ('IntersectionObserver' in window) {
			const itemObserver = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) return;
					entry.target.classList.add('is-visible');
					itemObserver.unobserve(entry.target);
					// After the entrance animation ends, clear the stagger delay so
					// hover and other future transitions are not delayed.
					entry.target.addEventListener('transitionend', () => {
						entry.target.style.setProperty('--item-col', 0);
					}, { once: true });
				});
			}, { threshold: 0.1 });

			// Only observe items not yet animated in
			items
				.filter(item => !item.classList.contains('is-visible'))
				.forEach(item => itemObserver.observe(item));
		} else {
			// Fallback for browsers without IntersectionObserver
			items.forEach(item => item.classList.add('is-visible'));
		}
	}

	// Trigger after each FacetWP load (covers the initial render and every
	// subsequent filter change or "load more"). The short delay lets Masonry
	// finish positioning items before we read offsetLeft values.
	jQuery(document).on('facetwp-loaded', function () {
		setTimeout(initGridItemAnimation, 150);
	});

	// ---------------------------------------------------------------------------
	// Scroll-triggered fade-in animation for hero section
	// ---------------------------------------------------------------------------

	/**
	 * Set up IntersectionObserver for .hero elements to trigger fade-in animation
	 * when they enter the viewport.
	 */
	function initHeroAnimation() {
		const heroes = document.querySelectorAll('.hero');
				console.log('Initializing hero animation');
				console.log('Heroes:', heroes);

		if (!heroes.length) return;

		if ('IntersectionObserver' in window) {
			const heroObserver = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) return;
					entry.target.classList.add('is-visible');
					heroObserver.unobserve(entry.target);
				});
			}, { threshold: 0.1 });

			heroes.forEach(hero => heroObserver.observe(hero));
		} else {
			// Fallback for browsers without IntersectionObserver
			heroes.forEach(hero => hero.classList.add('is-visible'));
		}
	}

	// Initialize hero animation on DOM ready
	jQuery(function () {
		initHeroAnimation();
		initUdGridAnimation();
	});

	// ---------------------------------------------------------------------------
	// Scroll-triggered slide-in animation for .cic-ud-grid__item elements
	// Mirrors the .item-document animation: items slide up from below with a
	// stagger delay based on their column position (--item-col CSS variable).
	// ---------------------------------------------------------------------------

	/**
	 * Assign column indices and set up IntersectionObserver for .cic-ud-grid__item
	 * elements inside .cic-ud-grid.
	 */
	function initUdGridAnimation() {
		const container = document.querySelector('.cic-ud-grid');
		if (!container) return;

		const parentColumn = container.closest('.wp-block-column');

		if (parentColumn && !parentColumn.classList.contains('is-visible')) {
			// The existing colObserver uses threshold:0.25, which is never met when
			// the column is very tall (e.g. a single-column grid at ≤575px with
			// 12 stacked items). Re-observe with threshold:0 so any visible pixel
			// triggers it, then force is-visible ourselves and wait for the column
			// transition to finish (overflow:hidden still clips items mid-transition).
			const colFallback = new IntersectionObserver((entries, self) => {
				if (!entries[0].isIntersecting) return;
				self.disconnect();
				parentColumn.classList.add('is-visible');
				let proceeded = false;
				const go = () => {
					if (proceeded) return;
					proceeded = true;
					_observeUdGridItems(container);
				};
				parentColumn.addEventListener('transitionend', go, { once: true });
				setTimeout(go, 700); // fallback if transitionend never fires
			}, { threshold: 0 });
			colFallback.observe(parentColumn);
			return;
		}

		_observeUdGridItems(container);
	}

	function _observeUdGridItems(container) {
		const items = Array.from(container.querySelectorAll('.cic-ud-grid__item'));
		if (!items.length) return;

		// Derive column index from offsetLeft: items sharing the same left offset
		// belong to the same grid column.
		const uniqueLefts = [...new Set(items.map(item => item.offsetLeft))].sort((a, b) => a - b);
		items.forEach(item => {
			item.style.setProperty('--item-col', uniqueLefts.indexOf(item.offsetLeft));
		});

		if ('IntersectionObserver' in window) {
			const udObserver = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					if (!entry.isIntersecting) return;
					entry.target.classList.add('is-visible');
					udObserver.unobserve(entry.target);
					// After the entrance animation ends, clear the stagger delay so
					// hover and other future transitions are not delayed.
					entry.target.addEventListener('transitionend', () => {
						entry.target.style.setProperty('--item-col', 0);
					}, { once: true });
				});
			}, { threshold: 0.1 });

			items
				.filter(item => !item.classList.contains('is-visible'))
				.forEach(item => udObserver.observe(item));
		} else {
			// Fallback for browsers without IntersectionObserver
			items.forEach(item => item.classList.add('is-visible'));
		}
	}

